var map = {
	"./AFlorDoCafe.png": 7390,
	"./CemiterioPrevida.png": 2968,
	"./Floresvida.png": 4723,
	"./GRUPOPARQUE.png": 4113,
	"./LogoGrupoParqueBranca.png": 2711,
	"./Memorial.png": 3806,
	"./MemorialFlores.png": 3067,
	"./ParqueAgreste.png": 2537,
	"./ParqueFlores.png": 8965,
	"./Previda.png": 2251,
	"./grupoparque2.png": 9799,
	"./grupoparque3.png": 6782,
	"./logo_memorial_branca.png": 8812
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9514;